import { useWindowDimensions } from "react-native";

const thresholdMap: Record<Threshold, number> = {
  xs: 600,
  sm: 800,
};

export type Threshold = "xs" | "sm";

export interface VisuallyHiddenProps {
  threshold?: Threshold;
  children?: React.ReactNode;
}

export const VisuallyHidden = ({
  threshold = "sm",
  children,
}: VisuallyHiddenProps) => {
  const layout = useWindowDimensions();
  const thresholdWidth = thresholdMap[threshold];

  if (layout.width < thresholdWidth) {
    return null;
  }

  return children;
};
